import React from 'react';
import { setCurrentView } from 'core/utils';
import { UploadDocumentTemplate } from 'themes/modules/order/pages';
import UploadDocumentViewStore from '../stores/UploadDocumentViewStore';

@setCurrentView((rootStore, componentProps) => new UploadDocumentViewStore(rootStore, componentProps), 'uploadDocumentViewStore')
class UploadDocument extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <UploadDocumentTemplate {...this.props} />;
	}
}

export default UploadDocument;
